import { render, staticRenderFns } from "./TransfereCards.vue?vue&type=template&id=df221700"
import script from "./TransfereCards.vue?vue&type=script&lang=js"
export * from "./TransfereCards.vue?vue&type=script&lang=js"
import style0 from "./TransfereCards.vue?vue&type=style&index=0&id=df221700&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports